import { createContext } from "react";
import { CatalogByCsr, CatalogItem, CatalogListByCsr } from "src/context/Actions/useActionScore";

export const CatalogViewsValues = ["grid", "list"] as const;
export type CatalogViews = (typeof CatalogViewsValues)[number];
export const isCatalogView = (v: string | null): v is CatalogViews => {
    if (v === null) return false;
    return CatalogViewsValues.includes(v as CatalogViews);
};

export type CatalogInitialValues = {
    actionsByParents: CatalogListByCsr;
    areActionsReady: boolean;
    isCatalogEmpty: boolean;

    currentCatalog: CatalogByCsr | undefined;
    currentAction: CatalogItem | undefined;

    hideAddedActions: boolean;
    setHideAddedActions: (v: boolean) => void;

    catalogView: CatalogViews;
    setCatalogView: (v: CatalogViews) => void;
};
export const CatalogContext = createContext<CatalogInitialValues | null>(null);
